import { css } from "@emotion/css";
import styled from "@emotion/styled";
import { Colors, FontWeight, Fonts, Spacing } from "@snapchat/snap-design-system";

export const lensCloudHeaderCss = css`
    display: flex;
    gap: ${Spacing["1XS"]}px;
    align-items: center;

    font-size: ${Fonts.Paragraph.P100};
    font-weight: ${FontWeight.MEDIUM};
    color: ${Colors.Black.V200};
`;

export const ModalBody = styled.span`
    ${Fonts.Paragraph.P200};
`;

export const bodyCss = css`
    ${Fonts.Paragraph.P200}
`;
